module.exports = __webpack_public_path__ + "img/editor_tray_2x.png?747b1929ca0377ef6ff9927666e26522";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/editor_tray_2x.png
// module id = 310
// module chunks = 0